export default "__VITE_ASSET__e188f861__"